import { render } from "./Wkd.vue?vue&type=template&id=3edf57ec&scoped=true"
import script from "./Wkd.vue?vue&type=script&lang=js"
export * from "./Wkd.vue?vue&type=script&lang=js"

import "./Wkd.vue?vue&type=style&index=0&id=3edf57ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3edf57ec"]])

export default __exports__